import { createFileRoute } from "@tanstack/react-router"
import { requireCap } from "@/lib/route-guards"

export const Route = createFileRoute("/_app/insights")({
  beforeLoad: requireCap("management"),
})
